import { fromJS } from 'immutable';
import * as ActionTypes from 'automation-ui-canvas/actions/ActionTypes';
import * as RequestStatus from 'automation-ui-canvas/constants/RequestStatus';
import DefaultWorkflows from 'automation-ui-canvas/constants/DefaultWorkflows';
import fromJSReviver from 'automation-ui-canvas/data/records/fromJSReviver';
const initialState = {
  value: {},
  hasFetchedAllWorkflows: false,
  requestStatus: RequestStatus.UNINITIALIZED,
  loadingAllError: null
};
function setupWorkflow(workflow, mergeInto) {
  const WorkflowRecord = DefaultWorkflows[workflow.type];
  if (!WorkflowRecord) {
    throw new Error(`Unknown workflow type (setupWorkflow): ${workflow.type}`);
  }
  const baseWorkflow = mergeInto || new WorkflowRecord(workflow);
  return baseWorkflow.mergeDeep(fromJS(workflow, fromJSReviver).filter((__, key) => baseWorkflow.has(key)));
}
export default function workflowsReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.REQUESTED_WORKFLOWS:
      return Object.assign({}, state, {
        requestStatus: RequestStatus.PENDING
      });
    case ActionTypes.RECEIVED_WORKFLOWS:
      {
        const allWorkflows = {};
        action.payload.workflows.forEach(workflow => {
          const fetchedWf = state.value[workflow.id];
          allWorkflows[workflow.id] = setupWorkflow(workflow, fetchedWf);
        });
        return Object.assign({}, state, {
          value: allWorkflows,
          hasFetchedAllWorkflows: true,
          requestStatus: RequestStatus.SUCCEEDED
        });
      }
    case ActionTypes.WORKFLOWS_REQUEST_FAILED:
      return Object.assign({}, state, {
        requestStatus: RequestStatus.FAILED,
        loadingAllError: action.payload
      });
    default:
      return state;
  }
}